import React, { Fragment, Component } from 'react';
import { Show, DateField, TextField } from 'react-admin';
import { AmountField, LinkField, EnhancedLinkField, JsonTextField } from '../../components/fields';
import { Grid, GridShowLayout } from '../../components/wrapper';

class BalanceTransactionShow extends Component {

	render() {
		return (
			<Fragment>
				<Show {...this.props} actions={undefined}>
					<GridShowLayout>
						<Grid container>
							<Grid item xs>
								<TextField source="id" />
								<TextField source="externalId" />
								<Grid container>
									<Grid item xs>
										<DateField source="creationDateTime" showTime />
									</Grid>
									<Grid item xs>
										<DateField source="cancellationDateTime" showTime />
									</Grid>
									<Grid item xs>
									</Grid>
								</Grid>
								<TextField source="operation" />
								<Grid container>
									<Grid item xs>
										<TextField source="type" />
									</Grid>
									<Grid item xs>
										<TextField source="subType" />
									</Grid>
									<Grid item xs>
									</Grid>
								</Grid>
								<Grid container>
									<Grid item xs>
										<AmountField source="amount" />
									</Grid>
									<Grid item xs>
										<AmountField source="amountLC" />
									</Grid>
									<Grid item xs>
									</Grid>
								</Grid>
								<Grid container>
									<Grid item xs>
										<AmountField source="reservedAmount" />
									</Grid>
									<Grid item xs>
										<AmountField source="capturedAmount" />
									</Grid>
									<Grid item xs>
										<AmountField source="refundedAmount" />
									</Grid>
								</Grid>
								<TextField source="status" />

							</Grid>
							<Grid item xs>
								<TextField source="description" />
								<LinkField source="transactionOwner" />
								<EnhancedLinkField source="otherAccount" />
								<LinkField source="walletAccountId" type="WalletAccount" />
								<TextField source="walletAccountItemId" />
								<TextField source="walletAccountItemOtherPart" />
								<AmountField source="minimumRemainingBalance" />
								<TextField source="categoryCode" />
							</Grid>
						</Grid>
						<Grid container>
							<Grid item xs>
								<JsonTextField source="transactionPayloadJson" fullWidth />
							</Grid>
						</Grid>
					</GridShowLayout>
				</Show>
			</Fragment>
		);
	}

};

export default BalanceTransactionShow;
